import { render, staticRenderFns } from "./DomesticPostageFee.vue?vue&type=template&id=02792b64&"
import script from "./DomesticPostageFee.vue?vue&type=script&lang=ts&"
export * from "./DomesticPostageFee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports